export enum LayerEnum {
  SITE_LAYER = 'SITE_LAYER',
  ROAD_LAYER = 'ROAD_LAYER',
  CAMERA_LAYER = 'CAMERA_LAYER',
}
